import script from "./ContentPlaceholders.vue?vue&type=script&setup=true&lang=js"
export * from "./ContentPlaceholders.vue?vue&type=script&setup=true&lang=js"

import "./ContentPlaceholders.vue?vue&type=style&index=0&id=e7ee75b8&scoped=true&lang=css"

import exportComponent from "/home/forge/hike.marketing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e7ee75b8"]])

export default __exports__